import React from 'react';

import {
  GridItemWrapper,
  GridTextWrapper,
  GridWrapper,
  HoverDek,
  HoverWrapper,
} from '@zola/zola-ui/src/components/PreAuthV3/Grid.styles';
import { HighlightTitle } from '@zola/zola-ui/src/components/PreAuthV3';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import { GridTextItem } from '@zola/zola-ui/src/components/PreAuthV3/Grid';
import { ForegroundImagesWrapper } from '@zola/zola-ui/src/components/PreAuthV3/FeaturedImage.styles';
import Image from 'next/image';
import { NextBackgroundForegroundImagesProps } from '../NextBackgroundForegroundImages/NextBackgroundForegroundImages';

import { ImageContainer } from './NextLpGrid.styles';

export type NextGridTextItem = Omit<GridTextItem, 'highlightTitle'> & {
  highlightTitle: JSX.Element;
};

export type NextLpGridProps = {
  className?: string;
  gridItems: (NextGridImageItem | NextGridTextItem)[];
};

export type NextGridImageItem = {
  imageProps: NextBackgroundForegroundImagesProps;
  hoverState?: {
    /**
     * The title of the hover state, wrap styled text in <strong> tags
     */
    hed: JSX.Element;
    dek?: string;
    href: string;
    linkText: string;
  };
};

const NextLpGrid = ({ className, gridItems }: NextLpGridProps): JSX.Element => {
  return (
    <div className={className}>
      <GridWrapper>
        {gridItems.map((item, i) => {
          if ('highlightTitle' in item) {
            const { highlightTitle, href, linkText } = item;
            return (
              <GridTextWrapper key={i}>
                <HighlightTitle isH1={false}>{highlightTitle}</HighlightTitle>
                <ButtonV3 component="a" href={href}>
                  {linkText}
                </ButtonV3>
              </GridTextWrapper>
            );
          }

          const { imageProps, hoverState } = item;
          const { hed, dek, href, linkText } = hoverState || {};
          const { foregroundImg, backgroundImg, bgColor } = imageProps;
          return (
            <GridItemWrapper hasHoverState={!!hoverState} key={i}>
              <ImageContainer bgColor={bgColor}>
                {backgroundImg && (
                  <Image
                    src={backgroundImg.src}
                    alt={backgroundImg.alt}
                    sizes="(max-width: 768px) 50vw, 33vw"
                    layout="fill"
                    objectFit="cover"
                    priority={false}
                  />
                )}
                {foregroundImg && (
                  <ForegroundImagesWrapper isWithBackgroundImage={Boolean(backgroundImg)}>
                    <Image
                      src={foregroundImg.src}
                      alt={foregroundImg.alt}
                      sizes="(max-width: 768px) 45vw, 30vw"
                      layout="fill"
                      objectFit="contain"
                      priority={false}
                    />
                  </ForegroundImagesWrapper>
                )}
              </ImageContainer>
              {hoverState && (
                <HoverWrapper>
                  {hed && <HighlightTitle isH1={false}>{hed}</HighlightTitle>}
                  {dek && <HoverDek>{dek}</HoverDek>}
                  <ButtonV3 component="a" href={href} variant="secondary">
                    {linkText}
                  </ButtonV3>
                </HoverWrapper>
              )}
            </GridItemWrapper>
          );
        })}
      </GridWrapper>
    </div>
  );
};

export default NextLpGrid;
